<template>
  <div v-if="connectionState.phase !== 'connected'">
    <div v-if="connectionState.phase === 'idle'">
      <BaseInformation
        :status="Status.INFO"
        information-text="Q-Tool einschalten und Suche starten."
      >
        <template #button>
          <PrimaryButton label="Q-Tool suchen" @click="$emit('scan')" />
        </template>
      </BaseInformation>
    </div>

    <div v-else-if="connectionState.phase === 'scanning'">
      <div class="flex items-center gap-2 text-sm mb-2">
        <em class="mdi mdi-loading mdi-spin text-primary-2" />
        <span>Suche nach Q-Tools in der Nähe…</span>
      </div>

      <div
        v-if="connectionState.devices.length > 0"
        class="flex flex-col gap-2"
      >
        <button
          v-for="device in connectionState.devices"
          :key="device.address"
          class="flex items-center gap-3 w-full rounded-lg border border-light-3 dark:border-dark-3 bg-white dark:bg-dark-2 p-3 text-left transition-colors hover:bg-light-2 dark:hover:bg-dark-3 active:bg-light-3"
          @click="$emit('connect', device)"
        >
          <em class="mdi mdi-cellphone-wireless text-lg text-primary-2" />
          <span class="flex-1 text-sm font-medium">{{ device.name }}</span>
          <em
            class="mdi mdi-chevron-right text-light-disabled-text dark:text-dark-disabled-text"
          />
        </button>
      </div>
    </div>

    <div
      v-else-if="connectionState.phase === 'connecting'"
      class="flex items-center gap-2 text-sm"
    >
      <em class="mdi mdi-loading mdi-spin text-primary-2" />
      <span>Verbinde mit "{{ connectionState.device.name }}"…</span>
    </div>

    <div v-else-if="connectionState.phase === 'disconnected'">
      <BaseInformation
        :status="Status.ERROR"
        information-text="Die Verbindung zum Q-Tool wurde unterbrochen. Bitte erneut verbinden."
      >
        <template #button>
          <PrimaryButton label="Erneut suchen" @click="$emit('scan')" />
        </template>
      </BaseInformation>
    </div>

    <div v-else-if="connectionState.phase === 'error'">
      <BaseInformation
        :status="Status.ERROR"
        :information-text="connectionState.message"
      />
      <PrimaryButton
        class="mt-4"
        label="Erneut suchen"
        @click="$emit('scan')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { QToolConnectionPhase } from '@/composables/useQToolConnection';
import type { QToolDevice } from '@/native/plugins/QTool';
import BaseInformation from '@/components/UI/Hint/BaseInformation.vue';
import PrimaryButton from '@/components/UI/Button/PrimaryButton.vue';
import { Status } from '@/enums/generic';

defineProps<{
  connectionState: QToolConnectionPhase;
}>();

defineEmits<{
  scan: [];
  connect: [device: QToolDevice];
}>();
</script>
